import { ChatInterface } from '@/components/chat/ChatInterface'

const Index = () => {
  return <ChatInterface />
}

export default Index
